import React from 'react'
import links from 'links'
import { track } from 'analytics'

import { Text } from 'components/dataDisplay'
import { Button } from 'components/inputs'

import { useSubscribeButton } from 'compositions/buttons/SubscribeButton/SubscribeButton'
import ProductPrice from 'compositions/ProductPrice/ProductPrice'

import OrderItemBase from '../OrderItemBase/OrderItemBase'
import OrderProductBase from '../OrderProductBase/OrderProductBase'

import messages from './messages'


type SubscriptionBannerProps = {
  className?: string
  onCancel: () => void
}

const SubscriptionBanner: React.FunctionComponent<SubscriptionBannerProps> = (props) => {
  const { className, onCancel } = props
  const { formattedPrice, formattedPriceWithDiscount, offerType,
    couponCode, eventDiscountText, handleSubscribeClick } = useSubscribeButton()

  const isSubCartOfferEnabled = offerType === 'discount'

  const trackParams = isSubCartOfferEnabled ? {
    discount: eventDiscountText,
    coupon: couponCode,
  } : {}

  const priceNode = isSubCartOfferEnabled && (
    <ProductPrice
      className="flex flex-col items-end"
      textStyle="p2"
      withNbsp={false}
      formattedData={{
        discountPrice: formattedPriceWithDiscount,
        standardPrice: formattedPrice,
      }}
    />
  )

  return (
    <div className={className} data-testid="subscriptionBanner">
      <Text style="h7" message={messages.title} />
      <OrderItemBase className="mt-16" data-testid="subscriptionBannerItem">
        <Text style="p2" message={messages.text} />
        <OrderProductBase
          className="mt-24"
          price={isSubCartOfferEnabled ? undefined : formattedPrice}
          priceNode={priceNode}
          data-testid="subscriptionCase"
        >
          <Text style="p2" message={messages.emptyProduct} />
        </OrderProductBase>
        <div className="mt-40 flex justify-center">
          <Button
            size={38}
            style="secondary"
            title={messages.no}
            onClick={onCancel}
            data-testid="cancelButton"
          />
          <Button
            className="ml-12"
            size={38}
            style="primary"
            title={messages.yes}
            to={links.subscribe}
            onClick={() => {
              track('Banner click', {
                placement: 'Cart',
                content: 'Subscribe',
                action: 'link',
                link: links.subscribe,
                ...trackParams,
              })

              if (isSubCartOfferEnabled) {
                // apply coupon
                handleSubscribeClick()
              }
            }}
            data-testid="confirmButton"
          />
        </div>
      </OrderItemBase>
    </div>
  )
}


export default React.memo(SubscriptionBanner)
